var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasTank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gas_tank_icon",
    "data-name": "Gas tank icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    transform: "translate(0 32) rotate(-90)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(7.838 6.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M.817,18.064A.817.817,0,0,1,0,17.247v-.524a.817.817,0,0,1,.817-.817H10.849a.817.817,0,0,1,.817.817v.524a.817.817,0,0,1-.817.817Zm.091-3.083V1.135a1.13,1.13,0,0,1,.333-.8A1.13,1.13,0,0,1,2.042,0H9.669a1.133,1.133,0,0,1,1.045.693,1.131,1.131,0,0,1,.089.441c-.023,8.543.052,9.31,0,13.846Zm2.1-11.935V6.269a.546.546,0,0,0,.545.545H8.045a.546.546,0,0,0,.545-.545V3.046A.546.546,0,0,0,8.045,2.5H3.553A.546.546,0,0,0,3.008,3.046Z",
    fill: "#ae60ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M7.212,10.924h.307a1.7,1.7,0,0,1,1.2.5,1.68,1.68,0,0,1,.5,1.2v1.7A.894.894,0,0,0,11,14.311V10.446h-.966a.4.4,0,0,1-.4-.4V5.994a.406.406,0,0,1,.23-.365l2.486-1.163v-.9l-2.5-1.285a.4.4,0,0,1,.367-.716l2.718,1.4a.4.4,0,0,1,.218.356v6.729a.4.4,0,0,1-.4.4H11.9v3.865a1.776,1.776,0,0,1-.523,1.262,1.789,1.789,0,0,1-2.911-.567,1.8,1.8,0,0,1-.137-.562h0V12.712a.9.9,0,0,0-.894-.894H7.212Z",
    transform: "translate(3.592 -0.744)",
    fill: "#ae60ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasTank);
export default __webpack_public_path__ + "static/media/gas-tank.00d9abea.svg";
export { ForwardRef as ReactComponent };